import { useEffect } from 'react';
import { usePopupManager } from '../../context/PopupManagerContext';
import { popupRegistry } from './popupRegistry';

/**
 * PopupManager Component
 *
 * This component:
 * 1. Registers all popups from the registry on mount
 * 2. Renders the current popup based on priority queue
 * 3. Handles popup dismissal
 *
 * Place this component in your App.tsx or Layout component
 */
const PopupManager = () => {
  const { registerPopup, unregisterPopup, currentPopup, dismissPopup } = usePopupManager();

  // Register all popups on mount
  useEffect(() => {
    popupRegistry.forEach((popup) => {
      registerPopup(popup);
    });

    // Cleanup: unregister all popups on unmount
    return () => {
      popupRegistry.forEach((popup) => {
        unregisterPopup(popup.id);
      });
    };
  }, [registerPopup, unregisterPopup]);

  const handleClose = () => {
    if (currentPopup) {
      dismissPopup(currentPopup.id);
    }
  };

  if (!currentPopup) {
    return null;
  }

  const PopupComponent = currentPopup.component;

  return (
    <PopupComponent
      {...currentPopup.props}
      onClose={handleClose}
    />
  );
};

export default PopupManager;
